exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Schedule__sticky--3JW3n {\n  position: fixed;\n  width: 100vw;\n  left: 0;\n  top: 60px;\n  background-color: #1e1f21;\n  display: flex;\n  justify-content: center;\n  z-index: 1;\n}\n\n.Schedule__keepHeight--359j6 {\n  height: 38px;\n}\n\n.Schedule__maxWidth--1xyyM {\n  max-width: 1024px;\n  width: 100vw;\n}\n\n@media (max-width: 768px) {\n  .Schedule__sticky--3JW3n {\n    top: 98px;\n  }\n}", ""]);

// exports
exports.locals = {
	"sticky": "Schedule__sticky--3JW3n",
	"keepHeight": "Schedule__keepHeight--359j6",
	"maxWidth": "Schedule__maxWidth--1xyyM"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };